function initialState() {
  return {
    loadingApp: false,
  }
}

export const globalStore = {
  namespaced: true,

  state: {
    initialState: initialState,
    loadingApp: initialState().loadingApp,
  },

  getters: {
    loadingApp(state) {
      return state.loadingApp
    },
  },

  mutations: {
    SET_LOADING_APP(state, loading) {
      state.loadingApp = loading
    },
  },

  actions: {
    resetAllStoresExcept({ dispatch, rootState }, exceptionStores = []) {
      for (const storeName in rootState) {
        const currentStore = rootState[storeName]
        if (
          !exceptionStores.includes(storeName) &&
          Object.keys(currentStore).includes('initialState')
        ) {
          dispatch(`${storeName}/resetStore`, null, { root: true })
        }
      }
    },
    resetStore({ commit }) {
      commit('SET_LOADING_APP', initialState().loadingApp)
    },
    setLoadingApp({ commit }, loading) {
      commit('SET_LOADING_APP', loading)
    },
  },
}
